import { useRouter } from 'next/router';

export const useLanguage = () => {
  const router = useRouter()
  return router.query.language;
}
